import { render, staticRenderFns } from "./ClientPF.vue?vue&type=template&id=780b7b5e"
import script from "./ClientPF.vue?vue&type=script&lang=js"
export * from "./ClientPF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports